export const dimensioningTracker = {
  actions: {
    editShipment: 'Dimensionamento: Botão Editar frete',
    listItemChangeProduct: 'Dimensionamento: Alterar produto',
    updateDimensioning: 'Atualizar dimensionamento',
    buttonOrderBook:
      'Dimensionamento: Clicou em reservar para iniciar o procedimento de reserva do pedido',
  },
}
